import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import HttpBase from '../models/httpBase';
import EnvironmentService from '../services/environmentService';
import Navigation from '../models/navigation';

@Injectable()
export default class NavigationService extends HttpBase {

  constructor(http: Http, router: Router, private environmentService: EnvironmentService) {
    super(http, router);
  }

  getJurisdictions(): Observable<Navigation> {
    return this.httpGet(this.environmentService.navigationUrl)
      .map((r: Response) => {
        return  Navigation.createFromRequest(r.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/navigationService.ts